import React from 'react';
import PropTypes from 'prop-types';
import { s3 } from 'app/utils';
import { useSelector, useDispatch } from 'react-redux';
import { updateUser } from 'modules/auth/auth.actions';
import SettingsModalComponent from 'modules/profile/web/settingsModal.component';
import { browserAlerts } from 'app/utils/alert';
import ToggleContainer from 'modules/profile/settings/toggle.container';
import MetamasLogin from 'modules/auth/web/login.web3';
import { Box, Header, View, Text, EthAddress } from 'modules/styled';

SettingsModalContainer.propTypes = {
  close: PropTypes.func,
};

export default function SettingsModalContainer({ close }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const submit = async (vals) => {
    try {
      const allVals = { ...vals };
      if (allVals.image && allVals.image.preview && allVals.image.fileName) {
        const imageUrl = await s3.uploadFile(
          allVals.image.preview,
          allVals.image.fileType
        );
        allVals.image = imageUrl;
      }
      const resp = await dispatch(updateUser(allVals));
      if (resp) close();
    } catch (err) {
      browserAlerts.alert(err);
    }
  };

  return (
    <View>
      <SettingsModalComponent
        initialValues={user}
        enableReinitialize={true}
        onSubmit={submit}
      />
      <Box sx={{ mt: 4 }} />
      <Header>Connect Accounts</Header>
      <View
        sx={{
          my: 3,
          flexDirection: ['column', 'row'],
          alignItems: ['flex-start', 'center'],
        }}
      >
        <MetamasLogin type="metamask" text={'Connect Ethereum Address'} />
        {user.ethLogin ? (
          <Text>
            Connected address: <EthAddress address={user.ethLogin} />
          </Text>
        ) : (
          <Text sx={{ mt: [1, 0] }}>Not connected</Text>
        )}
      </View>
      <ToggleContainer />
    </View>
  );
}
